import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import Swal from 'sweetalert2';
import { Translators } from '../../services/shared/translators.service';
import { Subscription } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../app.config/app.config';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';

@Component({
  selector: 'app-resend-pin',
  templateUrl: './resend-pin.component.html',
  styleUrls: ['./resend-pin.component.scss']
})
export class ResendPinComponent implements OnInit {

  form: FormGroup;
  idioma: Subscription;
  siteKey: string;

  constructor(
    private authservice: AuthService,
    private route : Router,
    private translatorService: Translators,
    @Inject(APP_CONFIG) private iAppConfig: IAppConfig,
    public guiMsjService: GuiMsjService,
  ) {
    this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
      this.idioma = resp;
    });
    this.createForm();
  }

  ngOnInit() {
    this.setSiteKey(this.iAppConfig.recaptcha.siteKey);
  }

  useLanguage(idioma: string){
    this.translatorService.setIdiomaSeleccionado(idioma);
  }

  setSiteKey(key: string) {
    this.siteKey = key;
  }

  get emailNoValido(){
    return this.form.get('email').invalid && this.form.get('email').touched;
  }

  createForm() {
    this.form = new FormGroup({
        email: new FormControl('', [ Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'), ]),
        recaptcha: new FormControl('', Validators.required)
    });
  }

  async resendPin(){

    if (this.form.invalid){
      return Object.values( this.form.controls ).forEach( control => {
          control.markAsTouched();
      } );
    }

    this.authservice.resendPin(
      this.form.value.email
    );

    await this.guiMsjService.msjFormSubmit('Espere');
    Swal.showLoading();

  }

}
